import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
  Space,
  Switch,
  Table,
} from 'antd'
import { unwrapResult } from '@reduxjs/toolkit'
import { EditableList } from '../../compnents/list/EditableList'
import styles from './Retail.module.css'
import { YBJSSJColumns } from './column'
import { DateRangeType, DateSelect, getDateRange } from '../../compnents/form/DateSelect'
import moment from 'moment'
import { DateTimeFormatSimple, DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { getSelectDrugTradeSubItemListAsync } from './retailSlice'
import { sum } from 'lodash'
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
}
const { Option } = Select

const { TextArea } = Input

export const YBJRJSModal = (props: {
  name?: string
  patientId?: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const inputRef = useRef<Input>(null)

  const dispatch = useDispatch<RootDispatch>()

  const [head, tail] = getDateRange(DateRangeType.ThisMonth)

  const [isClassifiedByDiseaseChecked, setIsClassifiedByDiseaseChecked] = useState(false)

  const [form] = Form.useForm()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    timeHead: moment(head).format(DateTimeFormatSimpleOnlyOne),
    timeTail: moment(tail).format(DateTimeFormatSimpleOnlyOne),
    drugType: '1',
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [pageLoading, setPageLoading] = useState(false)

  const [countTotal, setCountTotal] = useState<any>('')

  useEffect(() => {
    if (props.visible) {
      getList()
    }
  }, [props.visible, params])

  useEffect(() => {
    if (!props?.visible) {
      setPage({
        total: 0,
        items: [],
      })
      setParams({
        ...params,
        drugType: '1',
        timeHead: moment(head).format(DateTimeFormatSimpleOnlyOne),
        timeTail: moment(tail).format(DateTimeFormatSimpleOnlyOne),
        current: 1,
        size: 10,
      })
      form.resetFields()
      setIsClassifiedByDiseaseChecked(false)
    } else {
      form.setFieldsValue({
        drugType: '1',
      })
    }
  }, [props?.visible])


  const getList = () => {
    setPageLoading(true)
    dispatch(getSelectDrugTradeSubItemListAsync({ ...params, patientId: props.patientId }))
      .then(unwrapResult)
      .then((v) => {
        setPage({
          total: v?.total || 0,
          items: v?.records || [],
        })
        setCountTotal(sum(v?.records?.map((item: any) => item?.cnt > 0 ? item?.cnt : 0)))
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  return (
    <div>
      <Modal
        width='820px'
        title={(props?.name ? props?.name : ' ') + '医保结算数据'}
        visible={props.visible}
        maskClosable={false}
        bodyStyle={{ height: '630px', overflowY: 'hidden', padding: '15px 20px' }}
        onOk={() => {
          props.onOk()
          form.resetFields()
        }}
        onCancel={() => {
          form.resetFields()
          props.onCancel()
        }}
        footer={null}
      >
        <Form
          autoComplete='off'
          {...layout}
          form={form}
          name='basic'
          onFinish={(values) => {
            console.log(values, "values")
            if (!values?.timeHead && values?._dateRange == 6) {
              return
            }
            const startTime = values?.timeHead ? moment(values?.timeHead).format(DateTimeFormatSimpleOnlyOne) : moment(head).format(DateTimeFormatSimpleOnlyOne)
            const endTime = values?.timeTail ? moment(values?.timeTail).format(DateTimeFormatSimpleOnlyOne) : moment(tail).format(DateTimeFormatSimpleOnlyOne)
            setParams({
              ...params,
              ...values,
              timeHead: startTime,
              timeTail: endTime,
              current: 1,
            })
          }}
        >
          <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <Space>
              <DateSelect
                placeholder='请选择时间'
                labelPrefix=''
                namePrefix='time'
                initialValue={DateRangeType.ThisMonth}
                allowClear={false}
                style={{ width: '8rem' }}
                onChange={() => {
                  form.submit()
                }}
              />
              <Form.Item name='drugType' noStyle>
                <Select
                  placeholder='请选择项目分类'
                  style={{ width: '8rem' }}
                  allowClear={false}
                  onChange={() => {
                    form.submit()
                  }}>
                  <Option value={''}>全部</Option>
                  <Option value={'1'}>诊疗</Option>
                  <Option value={'0'}>药品</Option>
                </Select>
              </Form.Item>
              <Button
                type='primary'
                loading={pageLoading}
                onClick={() => {
                  form.submit()
                }}>查询</Button>
            </Space>
            <Space>
              <Checkbox checked={isClassifiedByDiseaseChecked}
                onChange={() => {
                  setIsClassifiedByDiseaseChecked(!isClassifiedByDiseaseChecked)
                  setParams({
                    ...params,
                    groupByDisease: !isClassifiedByDiseaseChecked ? 1 : 0,
                  })
                }}>按疾病分类</Checkbox>
            </Space>
          </Row>
        </Form>
        <EditableList
          style={{ height: '500px', overflow: 'hidden' }}
          scroll={{ y: '26rem' }}
          loading={pageLoading}
          page={{
            current: params?.current || 1,
            size: params?.size || 10,
            total: page.total,
            items: page.items,
          }}
          columns={YBJSSJColumns(isClassifiedByDiseaseChecked)}
          onChangePage={(current, size) => {
            setParams({
              ...params,
              current,
              size,
            })
          }}
          // summary={() => (
          //   <Table.Summary fixed>
          //     <Table.Summary.Row className={styles.total}>
          //       <Table.Summary.Cell
          //         index={0}
          //         align='center'
          //         className={styles.total}
          //       >合计</Table.Summary.Cell>
          //       <Table.Summary.Cell
          //         index={1}
          //         className={styles.total}
          //       ></Table.Summary.Cell>
          //       <Table.Summary.Cell
          //         index={2}
          //         align='center'
          //         className={styles.total}
          //       >{isClassifiedByDiseaseChecked ? '' : countTotal}</Table.Summary.Cell>
          //       {isClassifiedByDiseaseChecked && (
          //         <Table.Summary.Cell
          //           index={3}
          //           align='center'
          //           className={styles.total}
          //         >{countTotal}</Table.Summary.Cell>
          //       )}
          //     </Table.Summary.Row>
          //   </Table.Summary>
          // )}
          onRow={() => ({
            onDoubleClick: () => {
              return
            },
          })}
        />
      </Modal>
    </div >
  )
}

